import activity from '@/components/icons/activity.vue';
import engage from '@/components/icons/engage.vue';
import book from '@/components/icons/book.vue';
import configure from '@/components/icons/configure.vue';
import billing from '@/components/icons/billing.vue';
import pipeline from '@/components/icons/pipeline.vue';
import topics from '@/components/icons/topics.vue';
import sources from '@/components/icons/sources.vue';
import creator from '@/components/icons/creator.vue';
import getStarted from '@/components/icons/getStarted.vue';

const freeNavigation = [
  {
    name: 'Get Started',
    href: '/admin/getStarted',
    icon: getStarted,
    current: true,
  },
  {
    name: 'Audience',
    href: '/admin/audience',
    icon: activity,
    current: true,
  },
  {
    name: 'Connect',
    href: '/admin/engage', // previously it was engage tab
    icon: engage,
    current: false,
  },
  {
    name: 'Configure',
    href: '/admin/configure',
    icon: configure,
    current: false,
  },
];

const creatorNavigation = [
  {
    name: 'Get Started',
    href: '/admin/getStarted',
    icon: getStarted,
    current: true,
  },
  {
    name: 'Audience',
    href: '/admin/audience',
    icon: activity,
    current: true,
  },
  {
    name: 'Connect',
    href: '/admin/engage', // previously it was engage tab
    icon: engage,
    current: false,
  },
  {
    name: 'Pipeline',
    href: '/admin/pipeline',
    current: false,
    icon: activity,
  },
  {
    name: 'Products',
    href: '/admin/products',
    icon: book,
    current: false,
  },
  {
    name: 'Configure',
    href: '/admin/configure',
    icon: configure,
    current: false,
  },
];

const adminnavigation = [
  {
    name: 'Get Started',
    href: '/admin/getStarted',
    icon: getStarted,
    current: true,
  },
  {
    name: 'Audience',
    href: '/admin/audience',
    icon: activity,
    current: true,
  },
  {
    name: 'Connect',
    href: '/admin/engage',
    current: false,
    icon: engage,
  },
  {
    name: 'Pipeline',
    href: '/admin/pipeline',
    current: false,
    icon: pipeline,
  },
  {
    name: 'Products',
    href: '/admin/products',
    icon: book,
    current: false,
  },
  {
    name: 'Feed Topics',
    href: '/admin/topics',
    icon: topics,
    current: false,
  },
  {
    name: 'Feed Source',
    href: '/admin/sources',
    icon: sources,
    current: false,
  },
  {
    name: 'Customers',
    href: '/admin/course-creators',
    icon: creator,
    current: false,
  },
  {
    name: 'Configure',
    href: '/admin/configure',
    icon: configure,
    current: false,
  },
  {
    name: 'Billing',
    href: '/admin/subscription',
    icon: billing,
    current: false,
  },
];

export {
  freeNavigation,
  creatorNavigation,
  adminnavigation,
};
